// extracted by mini-css-extract-plugin
export var videoHero = "_5x-4";
export var videoHeroImage = "_5x-5";
export var videoHeroOverlay = "_5x-6";
export var videoHeroSubtitle = "_5x-8";
export var videoHeroText = "_5x-7";
export var videoLauncher = "_5x-0";
export var videoLauncherIcon = "_5x-1";
export var videoLauncherSubtitle = "_5x-3";
export var videoLauncherTitle = "_5x-2";
export var videoPlayer = "_5x-a";
export var videoPlayerWrap = "_5x-9";